
export default function SkillsSection() {
  const skillCategories = [
    {
      title: "Creative Software & Tools",
      skills: [
        "Adobe Photoshop (10+ years)",
        "Adobe Illustrator (10+ years)",
        "Adobe InDesign (10+ years)",
        "Adobe Lightroom (10+ years)",
        "WordPress, Divi, Squarespace (10+ years)"
      ]
    },
    {
      title: "Creative Expertise",
      skills: [
        "Art Direction & Team Leadership",
        "Event, Portrait, and Commercial Photography",
        "Brand Identity Development",
        "Graphic Design for Print & Digital",
        "Marketing Collateral Creation",
        "Visual Storytelling"
      ]
    },
    {
      title: "Additional Skills",
      skills: [
        "Customer Service (18+ years)",
        "Staff Training & Supervision",
        "On-site Event Production"
      ]
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 leading-tight">
            Skills & 
            <span className="block font-medium">expertise</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            A comprehensive toolkit developed through years of hands-on experience in photography, design, and creative leadership.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {skillCategories.map((category, index) => (
            <div key={index} className="bg-white p-8 rounded-sm shadow-sm">
              <h3 className="text-lg font-medium text-gray-900 mb-6">{category.title}</h3>
              <div className="space-y-3">
                {category.skills.map((skill, idx) => (
                  <div key={idx} className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-gray-400 rounded-full flex-shrink-0"></div>
                    <span className="text-gray-600 text-sm">{skill}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-white p-8 rounded-sm shadow-sm max-w-4xl mx-auto">
            <h3 className="text-xl font-medium text-gray-900 mb-4">Awards & Honors</h3>
            <p className="text-gray-600 leading-relaxed">
              Recognized with multiple awards for creativity and community impact throughout my career. My commitment to excellence in visual storytelling and creative leadership has been acknowledged by industry peers and clients alike.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}